export const SETTINGS_PAGE_GUIDE = [
  "Chaque onglet correspond à une catégorie de réglages distincte.",
  "Un changement s'applique aux futures opérations, jamais rétroactivement.",
];

export const MODULE_LABELS: Record<string, string> = {
  M1: "Sécurité",
  M2: "Documents",
  M3: "Crédits client",
  M6: "Créances et pénalités",
  M11: "Épargne voyage",
  MAIL: "E-mails",
  REWARDS: "Récompenses",
  auth: "Authentification",
  settings: "Paramètres",
  party: "Clients et référents",
  documents: "Documents",
  payments: "Paiements",
  penalties: "Pénalités",
  remises: "Remises",
  billetterie: "Billetterie",
  shop: "PrestiShop",
  commission: "Commissions",
  epargne: "Épargne voyage",
  dashboard: "Tableau de bord",
  papeterie: "Papeterie",
};

export const MODULE_DESCRIPTIONS: Record<string, string> = {
  M1: "Règles appliquées à la connexion, aux OTP et au verrouillage des comptes.",
  M2: "Valeurs par défaut utilisées lors de la création des documents commerciaux.",
  M3: "Comportement des crédits client lorsqu'ils arrivent en fin de période de décision.",
  M6: "Montants et délais utilisés pour calculer les pénalités de créances.",
  M11: "Paramètres d'inscription et conversion vers l'épargne voyage.",
  MAIL: "Contrôle des envois par e-mail, de l'expéditeur et des rappels automatiques.",
  REWARDS:
    "Règles utilisées pour prévisualiser les récompenses clients, référents et employés.",
};
